/**
 * Editorial introduction for a promoted browse preset.
 *
 * `preset.intro` (see ../../presets.ts) is an ordered list of paragraph
 * strings, present only on the handful of presets deliberately promoted to
 * editorial hubs. Most presets carry no `intro` and this renders nothing —
 * the bare filtered listing (`PageHeader`'s computed lede) is unchanged for
 * everyone else.
 *
 * Plain server-rendered markup, no client-only behaviour, no fetch — the
 * copy already lives in the preset object every other part of this render
 * path already has in hand.
 */
import React from 'react';

const BrowseIntro = ({ preset }) => {
  const paragraphs = preset?.intro;
  if (!paragraphs || paragraphs.length === 0) return null;

  return (
    <div className="pp-browse__intro">
      {paragraphs.map((text, i) => (
        <p key={i}>{text}</p>
      ))}
    </div>
  );
};

export default BrowseIntro;
